import OpenChat from '~/src/components/OpenChatLink';
import { IDesktopSbpProps } from '~/src/features/payments-abn/components/SeasonTicketPayment/components/SbpPayment/types';
import SbpInstruction from '~/src/features/payments-abn/components/useSbpPayment/SbpInstruction';

import * as ST from './styled';

const DesktopSbp = ({
    isDisabled,
    loading,
    isQrCodeError,
    qrCode,
    onClick,
}: IDesktopSbpProps): JSX.Element => {
    return (
        <ST.QrBlock>
            <ST.QrSide>{qrCode
                ? <ST.QrInner dangerouslySetInnerHTML={{ __html: qrCode }}/>
                : <ST.QrInner>
                    {isQrCodeError && (
                        <ST.QrError>
                            Ошибка. Попробуйте снова или обратитесь в&nbsp;<OpenChat><ST.SupportLink>поддержку</ST.SupportLink></OpenChat>.
                        </ST.QrError>
                    )}
                    <ST.QrButton
                        bType={'secondary'}
                        size={'small'}
                        disabled={isDisabled}
                        loading={loading}
                        onClick={onClick}
                    >
                        Показать QR-код
                    </ST.QrButton>
                </ST.QrInner>
            }</ST.QrSide>
            <ST.InfoSide>
                <ST.InfoTitle>Как оплатить через СБП</ST.InfoTitle>
                <SbpInstruction/>
            </ST.InfoSide>
        </ST.QrBlock>
    );
};

export default DesktopSbp;
